import { goURL } from '../../../webmodule-common/other/ui/resource-resolver';

export const resourcePurchaseOrder = 'purchaseOrder';
export async function launchPurchaseOrder(id: string) {
  goURL(resourcePurchaseOrder, id);
  return true;
}
